var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementMbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5784 17.3869C25.7086 24.8871 18.1121 29.4516 10.611 27.5813C3.1131 25.7115 -1.45137 18.1145 0.419286 10.6149C2.2883 3.11392 9.88478 -1.4509 17.3835 0.418935C24.8841 2.28877 29.4483 9.88655 27.5782 17.3871L27.5784 17.3869H27.5784Z",
    fill: "url(#paint0_linear_4732_8529)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1721 12.0056C20.4507 10.1425 19.0323 9.14096 17.0926 8.47286L17.7219 5.9491L16.1856 5.56629L15.573 8.02361C15.1692 7.92287 14.7544 7.82796 14.3422 7.73387L14.9591 5.26033L13.4238 4.87752L12.7942 7.40047C12.46 7.32437 12.1317 7.24916 11.8133 7.16992L11.815 7.16198L9.69646 6.63293L9.28778 8.27379C9.28778 8.27379 10.4276 8.53507 10.4036 8.55115C11.0257 8.70642 11.1382 9.11824 11.1195 9.44466L10.4027 12.3198C10.4456 12.3307 10.5011 12.3464 10.5625 12.3711C10.5112 12.3584 10.4567 12.3445 10.4001 12.3309L9.39542 16.3586C9.3194 16.5476 9.12642 16.8313 8.69147 16.7235C8.70686 16.7459 7.57486 16.4449 7.57486 16.4449L6.81212 18.2035L8.81136 18.7018C9.18329 18.7951 9.54775 18.8927 9.90668 18.9845L9.27095 21.5372L10.8055 21.92L11.435 19.3944C11.8542 19.5082 12.2611 19.6132 12.6593 19.7121L12.0319 22.2258L13.5683 22.6086L14.2039 20.0607C16.8236 20.5565 18.7934 20.3566 19.6226 17.9871C20.2907 16.0793 19.5893 14.9789 18.2111 14.2614C19.2149 14.0299 19.971 13.3696 20.1726 12.0058L20.1721 12.0054L20.1721 12.0056ZM16.662 16.9276C16.1872 18.8354 12.9752 17.8041 11.9338 17.5455L12.7774 14.1636C13.8187 14.4236 17.1582 14.938 16.6621 16.9276H16.662ZM17.1371 11.9779C16.704 13.7132 14.0306 12.8316 13.1633 12.6154L13.9282 9.54827C14.7954 9.76444 17.5883 10.1679 17.1373 11.9779H17.1371Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4732_8529",
    x1: 9.68038,
    y1: -0.0166822,
    x2: 21.0285,
    y2: 32.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F2FF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A5A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementMbtc);
export default __webpack_public_path__ + "static/media/movement-mbtc.f23b58d402c4ac77c10e3d21d7823708.svg";
export { ForwardRef as ReactComponent };